module.exports = __webpack_public_path__ + "img/menu-meter.66c4aaa5.png";